export default "__VITE_ASSET__CgRqgmpd__"